import { css } from 'styled-system/css';

export function AgentDot() {
  return (
    <span
      className={css({
        width: '8px',
        height: '8px',
        borderRadius: 'full',
        flexShrink: 0,
        background:
          'linear-gradient(135deg, token(colors.prism.violet), token(colors.prism.green))',
      })}
    />
  );
}
